module.exports = __webpack_public_path__ + "img/lamp-2x.87f0a399.png";